// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2e6ao","col":"styles_col__2DLtk","fulfillmentStatus":"styles_fulfillmentStatus__3P5Bm","emailCol":"styles_emailCol__122Rz"};